import React, { ReactNode } from "react";

// Mui components
import { Box, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

import { WORK_HISTORY_ZINDEX } from "constants/styles";

// Types
import { TPosition } from "./usePopoverPosition";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            background: theme.palette.common.white,
            borderRadius: 10,
            boxShadow: `0 3px 10px 1px ${theme.palette.others.darkestColor}44`,
            zIndex: WORK_HISTORY_ZINDEX,
            position: "absolute",
            minWidth: 340,
            maxWidth: 500,
        },
        header: {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            display: "flex",
            justifyContent: "space-between",
            padding: theme.spacing(1.5),
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
        },
        body: {
            fontSize: 14,
            padding: theme.spacing(0, 1.2),
        },
        closeIcon: {
            fontSize: 16,
            padding: 0,
            color: theme.palette.common.white,
        },
    })
);

const CustomPopover = React.forwardRef(function Popover(
    {
        position,
        refContainer,
        refHeader,
        refBody,
        onClose,
        isLoading,
        Header,
        Body,
        isCompany,
    }: {
        position: TPosition;
        refContainer: (instance: HTMLDivElement | null) => void;
        refHeader: (instance: HTMLDivElement | null) => void;
        refBody: (instance: HTMLDivElement | null) => void;
        onClose: (ev: React.MouseEvent<HTMLButtonElement>) => void;
        isLoading: boolean;
        Header: ReactNode;
        Body: ReactNode;
        isCompany?: boolean;
    },
    ref
) {
    const classes = useStyles();

    return (
        <div ref={ref as React.Ref<HTMLDivElement>}>
            <div
                style={{
                    left: position.left,
                    top: position.top,
                    width: isLoading ? 200 : "auto",
                    height: isLoading ? 200 : "auto",
                    minWidth: isLoading ? 0 : undefined,
                    visibility: isLoading || (position.left !== -1 && position.top !== -1) ? "visible" : "hidden",
                }}
                className={classes.container}
                ref={refContainer}
            >
                {isLoading ? (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        height="100%"
                        zIndex={WORK_HISTORY_ZINDEX + 100}
                    >
                        <CircularProgress color="primary" />
                    </Box>
                ) : (
                    <>
                        <Box className={classes.header} ref={refHeader}>
                            <Box>{Header}</Box>
                            <IconButton size="small" className={classes.closeIcon} aria-label="close" onClick={onClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Box>
                        <Box className={isCompany ? classes.body : ""} ref={refBody}>
                            {Body}
                        </Box>
                    </>
                )}
            </div>
        </div>
    );
});

export default CustomPopover;
